import React, { Component } from 'react';
import { Form, Select, Icon, Cascader, message, Input, Button, Modal, Row, Col, Upload } from 'antd';
import '../../../static/css/index.css'
import { getMenuList, uploadImg, addMenu, updateMenu } from '../../../apis/api'

const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
};
const { Option } = Select;

class EditMenu extends Component {
  constructor(props) {
    super(props);
    this.state={
        type:'',
        parent_id:'',
        inputFocus:false,
        imageUrl:'',
        imageName:'',
        access_token:'',
        parentMenu_option:[{id:0,name:'无',child:2,isLeaf:true,state:1}]
    }
  }

  componentDidMount(){

    this.setState({access_token:sessionStorage.getItem('access_token')},()=>{
        if(this.props.visible){
            this.getParentMenuList();
        }
    })

  }

  
  componentWillReceiveProps(nextProps) { 
    if(nextProps.visible!==this.props.visible){
        if(nextProps.visible){
            this.getParentMenuList();
        }
        if(nextProps.details&&nextProps.details.id!==this.props.details.id){
            this.setState({imageName:nextProps.details.logo,imageUrl:nextProps.details.logo_url,type:nextProps.details.type,parent_id:nextProps.details.parent_id})
        }
    }
  }

  changeParentId = (value) =>{
    //   console.log(value)
      this.setState({parent_id:value[0]})
  }

  focusCascader = () =>{
    this.setState({inputFocus:true})
  }

  getParentMenuList(){
    let _this=this;
    const { access_token, parentMenu_option } = this.state;
    let params={
        access_token:access_token,
        parent_id:0,
        // state:1,
        page:1,
        page_size:9999
    }
    getMenuList(params).then( (data)=> {
  
        if(data.code === 0){
          let list=data.content.list;
          list.map(item=>{
            if(item.child===1){
                item.isLeaf=false;
            }else{
                item.isLeaf=true;
            }
            if(item.state===2){
                item.disabled=true;
            }
            if(item.type===3){
                item.disabled=true;
            }
            parentMenu_option.push(item)
            return item;
          })

          _this.setState({ parentMenu_option })
          
        }else{

            message.error(data.message); 
        }
    });

  }

  loadData = selectedOptions => {
    const { access_token, parentMenu_option } = this.state;
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    let params={
        access_token:access_token,
        parent_id:targetOption.id,
        // state:1,
        page:1,
        page_size:9999
    }
    
    getMenuList(params).then( (data)=> {
  
        if(data.code === 0){
          targetOption.loading = false;
          let list=data.content.list;
           
           list.map(item=>{
            if(item.child===1){
                item.isLeaf=false;
            }else{
                item.isLeaf=true;
            }
            if(item.state===2){
                item.disabled=true;
            }
            if(item.type===3){
                item.disabled=true;
            }
            if(selectedOptions.length===2){
                item.isLeaf=true;
            }
            return item;
           })
         
          targetOption.children = list;
          this.setState({
            parentMenu_option: [...parentMenu_option],
          });

        }else{

            message.error(data.message); 
        }
    });
  };

  changeType = (value) =>{
      this.setState({type:value})
  }

  uploadImg = (info) =>{

    let _this=this;
    this.setState({ loading: true },()=>{
        let formData = new FormData();
        formData.append('img', info.file);
        formData.append('access_token', this.state.access_token);

        uploadImg(formData).then( (data)=> {
            if(data.code===0){
                let imageUrl=data.content.url;
                let imageName=data.content.img;
                _this.setState({ loading:false, imageUrl, imageName },()=>{
                    _this.props.form.setFieldsValue({image_url:imageUrl})
                });
                message.success(`${info.file.name} 上传成功！`);
            }else{
                _this.setState({ loading:false });
                message.error(`${info.file.name} 上传失败！原因：${data.message}。`);
          }
        });

    });
    
  }

  // 点击取消按钮
  handleCancel = (e) => {
    this.setState({
      type:'',
      parent_id:'',
      inputFocus:false,
      imageUrl:'',
      imageName:'', 
      parentMenu_option:[{id:0,name:'无',child:2,isLeaf:true,state:1}]
    },()=>{
        this.props.form.resetFields();
        this.props.cancelModal();
    });
  }
  

  //选择框展示选择的最后一个层级
  displayRender = (label) =>{
    return label[label.length - 1];
  }

  // 增加菜单点击确定按钮
  handleOk = (e) => {
    let _this=this;
    const { access_token, imageName } = this.state;
    _this.props.form.validateFields((err, values) => {
      if(err) {
          console.log('submit error:' ,err);
      }else {
        values.access_token=access_token;
        values.parent_id=values.parent_id&&values.parent_id.length?values.parent_id[values.parent_id.length-1]:_this.props.details.parent_id;
        values.state=values.state?values.state:0;
        if(values.image_url){
             values.logo=imageName;
        }
        delete values.image_url;
        if(!_this.props.details.id){
            addMenu(values).then( (data)=> {
                if(data.code===0){
                    message.success('新增菜单成功！');
                    _this.setState({ type:'', parent_id:'',inputFocus:false, imageUrl:'', imageName:'', parentMenu_option:[{id:0,name:'无',child:2,isLeaf:true,state:1}] },()=>{
                        _this.props.cancelModal();
                        _this.props.getMenuList();
                        _this.props.getParentMenuList();
                        _this.props.form.resetFields();
                    })

                }else{
                    
                    message.error(data.message);
        
              }
            });
        }else{
            values.id=this.props.details.id;
            updateMenu(values).then( (data)=> {
                if(data.code===0){
                    message.success('修改菜单成功！');
                    _this.setState({ inputFocus:false, imageUrl:'', imageName:'', parentMenu_option:[{id:0,name:'无',child:2,isLeaf:true,state:1}] },()=>{
                        _this.props.cancelModal();
                        _this.props.getMenuList();
                        _this.props.getParentMenuList();
                        _this.props.form.resetFields();
                    })

                }else{
                    
                    message.error(data.message);
        
              }
            });
        }
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { visible, details } = this.props;
    const { parentMenu_option, imageUrl, inputFocus } = this.state;

    const type_options=[{id: 1,name: '普通菜单'},{id: 2,name: '跳转菜单'},{id: 3,name: '操作菜单'}];
    const state_options=[{id: 1,name: '正常'},{id: 2,name: '禁用'}];

    return (

       <div>

        <Modal
          title={details&&details.id?'更新菜单':'添加菜单'}
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确定"
          cancelText="取消"
        >

            <Form className='editMenu_form'>
                {details.id?
                <Form.Item label="菜单UUID" {...formItemLayout}>
                    <Input value={details.uuid} disabled/>
                </Form.Item>
                :''}

                {details.id&&!inputFocus?
                <Form.Item label="父级菜单" {...formItemLayout}>
                    <Input placeholder='请输入菜单名称' value={details.parent_name?details.parent_name:'无'} onClick={this.focusCascader}/>
                </Form.Item>
                :
                <Form.Item label="父级菜单" {...formItemLayout}>
                    {getFieldDecorator('parent_id', {
                        initialValue:[],
                        rules: [{ required: true, message: '请选择父级菜单!' }]
                    })(
                        <Cascader allowClear fieldNames={{ label: 'name', value: 'id', children: 'children' }} options={parentMenu_option}
                        loadData={this.loadData} placeholder="请选择" changeOnSelect displayRender={this.displayRender} onChange={this.changeParentId}/>
                    )}
                </Form.Item>
                }

                <Form.Item label="菜单名称" {...formItemLayout}>
                    {getFieldDecorator('name', {
                        initialValue:details&&details.name?details.name:'',
                        rules: [{ required: true, message: '请输入菜单名称!' }]
                    })(
                        <Input placeholder='请输入菜单名称' />
                    )}
                </Form.Item>

                <Form.Item label="菜单类型" {...formItemLayout}>
                    {getFieldDecorator('type', {
                        initialValue:details&&details.type?details.type:undefined,
                        rules: [{ required: true, message: '请选择菜单类型!' }]
                    })(
                        <Select allowClear placeholder='请选择' onChange={this.changeType}>
                           {type_options.map(opt=>{
                               return(
                                  <Option key={opt.id} value={opt.id}>{opt.name}</Option>
                               )
                           })}
                        </Select>
                    )}
                </Form.Item>

                {this.state.type===2?
                <Form.Item label="跳转地址" {...formItemLayout}>
                    {getFieldDecorator('redirect_url', {
                        initialValue:details&&details.redirect_url?details.redirect_url:'',
                        rules: [{ required: true, message: '请输入跳转地址!' }]
                    })(
                        <Input placeholder='请输入跳转地址(以"http://或https://"开头)' />
                    )}
                </Form.Item>
                :''}

                <Form.Item label="权限路由" {...formItemLayout}>
                    {getFieldDecorator('route', {
                        initialValue:details&&details.route?details.route:''
                    })(
                        <Input placeholder='请输入权限路由' />
                    )}
                </Form.Item>

                <Form.Item label="路由请求方式" {...formItemLayout}>
                    {getFieldDecorator('request_type', {
                        initialValue:details&&details.request_type?details.request_type:undefined
                    })(
                        <Select allowClear placeholder='请选择'>
                            <Option key='GET' value='GET'>GET</Option>
                            <Option key='POST' value='POST'>POST</Option>
                            <Option key='PUT' value='PUT'>PUT</Option>
                            <Option key='DELETE' value='DELETE'>DELETE</Option>
                        </Select>
                    )}
                </Form.Item>

                {this.state.parent_id===0?
                <Form.Item label="图标地址" {...formItemLayout}>
                    <Row gutter={3}>
                      <Col span={3}>
                        <Upload showUploadList={false} customRequest={this.uploadImg} >
                          <Button style={imageUrl ?{padding:0}:{}}>
                               {imageUrl ? <img src={imageUrl} alt="avatar" style={{width:32,height:32}}/> : ( <Icon type={this.state.loading ? 'loading' : 'upload'} />)}
                          </Button>
                       </Upload>
                      </Col>
                      <Col span={21}>
                         {getFieldDecorator('image_url', {
                            initialValue:imageUrl?imageUrl:'',
                            rules: [{ required: true, message: '请上传图标!' }]
                         })(
                            <Input placeholder="请上传图标" />
                         )}
                      </Col>
                    </Row>
                </Form.Item>
                :''}

                <Form.Item label="应用编号" {...formItemLayout}>
                {getFieldDecorator('app_id', {
                    initialValue:details&&details.app_id?details.app_id:'',
                    // rules: [{ required: true, message: '请输入应用编号!' }]
                })(
                    <Input placeholder='请输入应用编号' />
                )}
                </Form.Item>

                <Form.Item label="状态" {...formItemLayout}>
                    {getFieldDecorator('state', {
                        initialValue:details&&details.state?details.state:undefined,
                        rules: [{ required: true, message: '请选择状态!' }]
                    })(
                        <Select allowClear placeholder='请选择' >
                           {state_options.map(opt=>{
                               return(
                                  <Option key={opt.id} value={opt.id}>{opt.name}</Option>
                               )
                           })}
                        </Select>
                    )}
                </Form.Item>

                <Form.Item label="菜单顺序" {...formItemLayout}>
                    {getFieldDecorator('sort', {
                        initialValue:details&&details.sort?details.sort:'',
                        rules: [{ required: true, message: '请输入菜单顺序!' }]
                    })(
                        <Input placeholder='请输入菜单顺序' />
                    )}
                </Form.Item>

            </Form>
        </Modal>
             
       </div>
    );
  }
}

EditMenu = Form.create({
   
})(EditMenu);
export default EditMenu;



// WEBPACK FOOTER //
// ./src/page/Menu/components/editMenu.js